import { render } from "./ListDetails.vue?vue&type=template&id=71bb2914&scoped=true"
import script from "./ListDetails.vue?vue&type=script&lang=js"
export * from "./ListDetails.vue?vue&type=script&lang=js"

import "./ListDetails.vue?vue&type=style&index=0&id=71bb2914&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bb2914"]])

export default __exports__